
import React from "react";
import bg from "../assets/bg.webp";

const PolitikaPrivatnosti = () => {
  return (
    <div
      className=""
      style={{
        backgroundImage: `url(${bg})`,
        backgroundRepeat: "no repeat",
        backgroundSize: "100%",
      }}
    >
      <div className="flex flex-col items-center">
        <h1 className="text-5xl md:text-6xl mt-12 xl:mt-16 text-center sm:text-left px-6">
          Politika privatnosti
        </h1>
        <h2 className="text-xl md:text-2xl mt-6 pb-6 text-center sm:text-left px-3">
          Opšti podaci i podaci o rukovaocu koji obrađuje podatke
        </h2>
      </div>
      <div className="px-3 md:px-6 md:pr-24 md:ml-20">
        <h3 className="text-[22px] md:text-md lg:text-xl pt-6 mb-6 font-bold lg:mt-12 pl-2">
          Poštovani potrošači,
        </h3>
        <p className="text-[16px] md:text-md mb-6 pl-2 lg:px-12">
          Molimo vas da pažljivo pročitate Politiku privatnosti pre nego što
          obavite kupovinu. U postupku kupovine na sajtu pet-id.rs saglašavate
          se sa Politikom privatnosti i potvrđujete da ste pročitali, razumeli
          uslove pod kojima obrađujemo Vaše lične podatke i prihvatili Politiku
          privatnosti.
        </p>
        <p className="text-[16px] md:text-md mb-6 pl-2 lg:px-12">
          <b>Pet ID Beograd-Zvezdara,</b> 11000 Beograd, (u daljem tekstu: ”
          <b>Pet ID, Društvo, Platforma ili Mi</b>
          ”), poštuje i štiti privatnost svake osobe (fizičkih lica - korisnika
          platforme, potencijalnih korisnika ili drugih lica - u daljem tekstu
          zajedno označeni kao: „<b>Lice ili Vi</b>“) čije lične podatke
          prikuplja i obrađuje (u daljem tekstu: „<b>Lični podaci</b>“).
        </p>
        <p className="text-[16px] md:text-md mb-6 pl-2 lg:px-12">
          Prikupljanje, obrada i čuvanje Ličnih podataka Pet ID sprovodi u
          skladu sa Zakonom o zaštiti podataka o ličnosti („Službeni glasnik
          Republike Srbije“, br. 87/2018) (u daljem tekstu: „<b>Zakon</b>“).
        </p>
        <p className="text-[16px] md:text-md mb-6 pl-2 lg:px-12">
          Kako smo svesni da je privatnost važna za Vas i kako bismo zaštitili
          privatnost Lica čije Lične podatke prikupljamo, Mi smo doneli i
          objavili ovu Politiku privatnosti, koja definiše koje Lične podatke
          prikupljamo, na koji način, za koju svrhu ih obrađujemo, kako ih
          štitimo, koliko dugo ih čuvamo, i na kraju, koja su Vaša prava u vezi
          sa Vašim Ličnim podacima. S tim u vezi, Politika privatnosti prikazuje
          našu praksu u vezi sa prikupljanjem Ličnih podataka, bilo da ih
          prikupljamo direktno od Vas, od trećih lica, prilikom Vaše posete
          našem sajtu, putem Vaše pisane ili usmene komunikacije sa nama ili iz
          drugih izvora. U svakom slučaju, ukoliko imate pitanja ili nedoumice,
          budite slobodni da nas kontaktirate u svakom trenutku na email adresu:
          <b> petiddigital@gmail.com</b>
        </p>
        <p className="text-[18px] md:text-xl mb-6 pl-2 lg:px-12">
          Hvala na poverenju!
        </p>

        <h3 className="text-[22px] md:text-md lg:text-2xl pt-6 mb-6 font-bold lg:mt-12 pl-2 xl:pl-6">
          Osnovni pojmovi i Lični podaci koje Pet ID obrađuje:
        </h3>
        <p className="text-[16px] md:text-md mb-6 pl-2 lg:px-12">
          „<b>Lični podatak</b>“ je svaki podatak koji se odnosi na fizičko lice
          čiji je identitet određen ili odrediv, neposredno ili posredno,
          posebno na osnovu oznake identiteta, kao što je ime i identifikacioni
          broj, podataka o lokaciji, identifikatora u elektronskim
          komunikacionim mrežama ili jednog, odnosno više obeležja njegovog
          fizičkog, fiziološkog, genetskog, mentalnog, ekonomskog, kulturnog i
          društvenog identiteta;
        </p>
        <p className="text-[16px] md:text-md mb-6 pl-2 lg:px-12">
          „<b>Obrada podataka o ličnosti</b>“ je svaka radnja ili skup radnji
          koje se vrše automatizovano ili neautomatizovano sa podacima o
          ličnosti ili njihovim skupovima, kao što su prikupljanje, beleženje,
          razvrstavanje, grupisanje, odnosno strukturisanje, pohranjivanje,
          upodobljavanje ili menjanje, otkrivanje, uvid, upotreba, otkrivanje
          prenosom, odnosno dostavljanjem, umnožavanje, širenje ili na drugi
          način činjenje dostupnim, upoređivanje, ograničavanje, brisanje ili
          uništavanje;
        </p>

        <p className="text-[16px] md:text-md font-bold mb-6 pl-2 lg:px-12">
          Vaši privatni podaci kao sto su broj telefona, ime, prezime itd... će
          biti vidljivi i dostupni samo korisnicima koji očitaju QR kod sa
          priveska vašeg ljubimca.{" "}
        </p>
        <p className="text-[16px] md:text-md mb-6 pl-2 lg:px-12">
          Mi ne prikupljamo Lične podatke dece. Mi prikupljamo Lične podatke
          lica starijih od 15 godina i to samo za svrhu korišćenja usluga
          informacionog društva, shodno odredbi člana 16. Zakona o zaštiti
          podataka o ličnosti.
        </p>

        <h3 className="text-[22px] md:text-md lg:text-2xl pt-6 mb-6 font-bold lg:mt-12 pl-2 xl:pl-6">
          Načela obrade Ličnih podataka:
        </h3>
        <p className="text-[16px] md:text-md mb-6 pl-2 lg:px-12">
          Molimo Vas da imate u vidu da Mi, u svakom trenutku, prilikom
          prikupljanja, obrade i čuvanja Vaših Ličnih podataka, postupamo na
          sledeći način:
        </p>
        <p className="text-[16px] md:text-md mb-6 pl-6 lg:px-12 lg:pl-20">
          - Lični podaci će se obrađivati zakonito, pošteno i transparentno u
          odnosu na Lice na koje se podaci odnose („zakonitost, poštenje i
          transparentnost“);
        </p>
        <p className="text-[16px] md:text-md mb-6 pl-6 lg:px-12 lg:pl-20">
          - Lični podaci će se prikupljati u svrhe koje su konkretno određene
          ovom Politikom Privatnosti, koje su izričite, opravdane i zakonite i
          dalje se ne mogu obrađivati na način koji nije u skladu sa tim svrhama
          („ograničenje u odnosu na svrhu obrade“);
        </p>
        <p className="text-[16px] md:text-md mb-6 pl-6 lg:px-12 lg:pl-20">
          - Lični podaci će biti primereni, bitni i ograničeni na ono što je
          neophodno u odnosu na svrhu obrade („minimizacija podataka“);
        </p>
        <p className="text-[16px] md:text-md mb-6 pl-6 lg:px-12 lg:pl-20">
          - Lični podaci će biti tačni i, ako je to neophodno, ažurirani. S tim
          u vezi, Mi ćemo preduzeti sve razumne mere kojima se obezbeđuje da se
          netačni podaci o ličnosti bez odlaganja izbrišu ili isprave
          („tačnost“), a Vas molimo da nas uvek obavestite o promeni Vaših
          Ličnih podataka;
        </p>
        <p className="text-[16px] md:text-md mb-6 pl-6 lg:px-12 lg:pl-20">
          - Lični podaci će se čuvati u obliku koji omogućava identifikaciju
          Lica samo u roku koji je neophodan za ostvarivanje svrhe obrade
          („ograničenje čuvanja“);
        </p>
        <p className="text-[16px] md:text-md mb-6 pl-6 lg:px-12 lg:pl-20">
          - Lični podaci će se obrađivati na način koji obezbeđuje odgovarajuću
          zaštitu podataka o ličnosti, uključujući zaštitu od neovlašćene ili
          nezakonite obrade, kao i od slučajnog gubitka, uništenja ili oštećenja
          primenom odgovarajućih tehničkih, organizacionih i kadrovskih mera
          („integritet i poverljivost“).
        </p>

        <h3 className="text-[22px] md:text-md lg:text-2xl pt-6 mb-6 font-bold lg:mt-12 pl-2 xl:pl-6">
          Lični podaci koje Pet ID prikuplja i obrađuje o Vama ( podaci koji će
          se videti kad se učita QR kod ):
        </h3>
        <p className="text-[16px] md:text-md mb-1 pl-2 lg:px-12">
          - Ime ili samo nadimak,
        </p>
        <p className="text-[16px] md:text-md mb-1 pl-2 lg:px-12">
          - e-mail adresa, nije obavezno,
        </p>
        <p className="text-[16px] md:text-md mb-1 pl-2 lg:px-12">
          - Broj mobilnog telefona, nije obavezno,
        </p>
        <p className="text-[16px] md:text-md mb-1 pl-2 lg:px-12">
          - Adresa, nije obavezno.
        </p>

        <h3 className="text-[22px] md:text-md lg:text-2xl pt-6 mb-6 font-bold lg:mt-12 pl-2 xl:pl-6">
          Način prikupljanja Ličnih podataka:
        </h3>
        <p className="text-[16px] md:text-md mb-6 lg:mb-12 pl-3 lg:px-12">
          Lični podaci se prikupljaju neposredno od Vas, kao lica čiji se podaci
          obrađuju ili od strane drugih lica ako je neko naručio kao poklon vama
          za vašeg ljubimca.
        </p>

        <h3 className="text-[22px] md:text-md lg:text-2xl pt-6 mb-6 font-bold pl-2 xl:pl-6">
          Neposredno prikupljanje Ličnih podataka od Lica čiji se podaci
          obrađuju:
        </h3>
        <p className="text-[16px] md:text-md mb-6 pl-3 lg:px-12">
          Prilikom kupovine robe
        </p>
        <p className="text-[16px] md:text-md mb-6 pl-3 lg:px-12">
          Prilikom zaključenja ugovora o kupoprodaji robe sa trgovcem, a za
          svrhe zaključenja i izvršenja ugovora (uključujući isporuku robe,
          dostavljanje specifikacije porudžbine, računa za kupljenu robu, kao i
          drugih dokumenata koja se odnose na ugovor o kupoprodaji, dostavljanje
          obaveštenja da je pošiljka spremna za slanje odnosno preuzimanje na
          tačno određenoj adresi/lokaciji, dostavljanje identifikacionog koda za
          preuzimanje pošiljke itd), u obavezi ste da nam dostavite sledeće
          Lične podatke, koje podatke unosite prilikom kupovine robe:
          <b>
            ime i prezime, adresu prebivališta/adresu za isporuku robe (ulica,
            kućni broj, broj stana, grad, poštanski broj), broj mobilnog
            telefona/broj fiksnog telefona, email adresa.
          </b>
        </p>
        <p className="text-[16px] md:text-md mb-6 pl-3 lg:px-12">
          U slučaju da želite da se račun pošalje na adresu koja se razlikuje od
          adrese za isporuku robe, molimo Vas da nam dostavite sledeće Lične
          podatke lica kojem se roba isporučuje:{" "}
          <b>
            ime i prezime, adresu: ulica, kućni broj, broj stana, grad,
            poštanski broj, broj mobilnog telefona/broj fiksnog telefona
          </b>
          , kao i Lične podatke lica kojem se račun dostavlja:{" "}
          <b>ime i prezime, e-mail adresa.</b>
        </p>
        <p className="text-[16px] md:text-md mb-6 pl-3 lg:px-12">
          U slučaju da nam ne pružite navedene Lične podatke, Mi nećemo biti u
          mogućnosti da omogućimo zaključenje i izvršenje ugovora o kupoprodaji
          robe sa trgovcem, što uključuje i izdavanje računa.
        </p>
        <p className="text-[16px] md:text-md mb-6 pl-3 lg:px-12">
          Svrha zbog koje obrađujemo navedene Lične podatke jeste posredovanje u
          zaključenju i izvršenju ugovora o kupoprodaji robe sa trgovcem.
        </p>

        <h3 className="text-[22px] md:text-md lg:text-2xl pt-6 mb-6 font-bold pl-2 xl:pl-6">
          Pravni osnov obrade Ličnih podatka:
        </h3>
        <p className="text-[16px] md:text-md mb-6 pl-2 xl:pl-6">
          Shodno načelu zakonitosti, Mi obrađujemo Vaše Lične podatke na osnovu
          različitih, Zakonom propisanih, osnova, kao što su sledeći:
        </p>
        <h3 className="text-[18px] md:text-md lg:text-xl mb-6 font-bold pl-2 lg:px-12">
          - Vaš pristanak
        </h3>
        <p className="text-[16px] md:text-md mb-6 pl-6 lg:px-12 lg:pl-20">
          Vaši Lični podaci do kojih smo došli na osnovu Vaše kupovine priveska
          će se čuvati u našoj bazi, sve dok postoji Vaš pristanak, odnosno sve
          do eventualnog opoziva Vašeg pristanka. Pristanak za prikupljanje,
          obradu i korišćenje Vaših Ličnih podataka možete opozvati u svakom
          trenutku tako što ćete opozvati pristanak u okviru e-maila koji ste
          dobili od nas, a koji Vam omogućava da opozovete pristanak, kao i
          putem elektronskog zahteva na e-mail adresu: petiddigital@gmail.com
        </p>

        <h3 className="text-[18px] md:text-md lg:text-xl pt-6 mb-6 font-bold pl-2 lg:px-12">
          - Poverljivost Ličnih podataka i transparentnost
        </h3>
        <p className="text-[16px] md:text-md mb-6 pl-6 lg:px-12 lg:pl-20">
          Vaši Lični podaci će biti tretirani kao poverljive informacije i Mi
          ćemo preduzeti odgovarajuće potrebne mere kako bismo iste zaštitili u
          skladu sa Zakonom. Pristup njima imaće samo lica koja, s obzirom na
          opis posla koji obavljaju, treba da budu upoznata sa Vašim Ličnim
          podacima i to samo u obimu koji je neophodan za obavljanje njihovih
          poslova.
        </p>
        <p className="text-3xl mb-6 text-center font-bold pt-24">
          ♥ Vaš Pet ID ♥
        </p>
      </div>
    </div>
  );
};

export default PolitikaPrivatnosti;
